import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { LienholderFormData } from '../../../types';

import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';

import { transformLienholderToDxg, transformLienholderToForm } from './utils';
import type { OutsideLienHolder } from '@makemydeal/dr-platform-types';
import { paymentPayloadUtils } from '@makemydeal/dr-offer-redux';

export const useOutsideLienholderForm = () => {
    const dispatch = useDispatch();
    const sourceOutsideLienholderData = useSelector(offerReduxSelectors.getOutsideLienholder);
    const outsideLienholderData = transformLienholderToForm(sourceOutsideLienholderData);
    const govFees = useSelector(offerSelectors.getItemizedGovernmentFees);
    const [clearFields, setClearFields] = useState(false);

    const makePaymentCall = (currentValues: OutsideLienHolder) => {
        const previousHasData = paymentPayloadUtils.isOutsideLienHolderData(sourceOutsideLienholderData);
        const currentHasData = paymentPayloadUtils.isOutsideLienHolderData(currentValues);
        const lienFee = govFees.find((fee) => fee.code === 6);
        let payment = false;

        if ((!previousHasData && currentHasData && !lienFee) || (previousHasData && !currentHasData && lienFee)) {
            payment = true;
        }

        return payment;
    };

    const setOutsideLienholderData: Dispatch<SetStateAction<LienholderFormData>> = (value) => {
        const updatedFormData = typeof value === 'function' ? value(outsideLienholderData) : value;
        const updatedLienholderData = transformLienholderToDxg(updatedFormData);
        const payment = makePaymentCall(updatedLienholderData);
        dispatch(offerReduxActionCreators.setOutsideLienholder({ ...updatedLienholderData, payment }));
    };

    const handleClearAll = () => {
        setOutsideLienholderData({} as LienholderFormData);
        setClearFields((prev) => !prev);
    };

    const lienholderProps = {
        isTradeInCompleted: true,
        lienholderData: outsideLienholderData,
        setLienholderData: setOutsideLienholderData,
        isOutsideLienholder: true,
        clearFields
    };

    return { lienholderProps, onClearAll: handleClearAll };
};
